import { QuickQuestionCommonOptionsEnum } from '../types/quick-question-common-options.enum';
import { SuperpowerOptionIdsEnum } from '../types/superpower-option-ids.enum';
import { QuickQuestionOption } from './quck-question-option';

export const SuperpowerOptions: QuickQuestionOption[] = [
  {
    id: SuperpowerOptionIdsEnum.ResourcefulAndLoveToRunBusiness,
    name: 'txt_superpower_resourceful_and_love_to_runbusiness',
  },
  {
    id: SuperpowerOptionIdsEnum.ExperiencedWithMarketingAndAdvertising,
    name: 'txt_superpower_experienced_marketing_and_advertising',
  },
  { id: SuperpowerOptionIdsEnum.CanCreateBestsellingDesigns, name: 'txt_superpower_can_create_bestselling_designs' },
  { id: SuperpowerOptionIdsEnum.SeasonedEcommerceSeller, name: 'txt_superpower_seasoned_ecommerce_seller' },
  {
    id: SuperpowerOptionIdsEnum.InfluencerWithStrongCommunity,
    name: 'txt_superpower_influencer_with_strong_community',
  },
  { id: QuickQuestionCommonOptionsEnum.Other, name: 'txt_other' },
];
